import { Link } from '@tanstack/react-router'
import Button from '@/components/Button'
import { Star } from '@/components/Icons/Star'

interface ILeaderBoardNavbarProps {
  points: number
  streaks: number
}

const LeaderBoardNavbar = ({ points, streaks }: ILeaderBoardNavbarProps) => {
  return (
    <div className="h-20 top-0 flex w-full justify-between px-7 py-[15px] z-50 bg-action-500 border border-b-4 border-b-action-400 fixed">
      <div className="max-w-[1440px] w-full flex justify-between items-center px-7 py-4 mx-auto">
        <Link to="/dashboard">
          <Button size="sm" className="bg-neutral-100 hover:bg-neutral-200 text-action-600 border-0">
            Back
          </Button>
        </Link>
        <div className="bg-neutral-100 rounded-[30px] flex gap-x-[10px] px-[10px] py-1 text-neutral-600 text-[24px] items-center">
          <div className="flex items-center">🔥 {streaks}</div>
          <div className="flex items-center">
            <Star className="size-[25px]" /> {points}
          </div>
        </div>
      </div>
    </div>
  )
}

export default LeaderBoardNavbar